"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserOverallScore = addUserOverallScore;
exports.addUserScore = addUserScore;
exports.addUserScoreNew = addUserScoreNew;
exports.createHike = createHike;
exports.deleteUserOverallScore = deleteUserOverallScore;
exports.deleteUserScore = deleteUserScore;
exports.deleteUserScoreNew = deleteUserScoreNew;
exports.downloadTASRatingExcel = downloadTASRatingExcel;
exports.editComments = editComments;
exports.enrollHike = enrollHike;
exports.getAttendantReport = getAttendantReport;
exports.getDialTestData = getDialTestData;
exports.getEmailLog = getEmailLog;
exports.getExportSurveyResult = getExportSurveyResult;
exports.getFeedbackResults = getFeedbackResults;
exports.getHikeActivityReport = getHikeActivityReport;
exports.getHikeById = getHikeById;
exports.getHikeList = getHikeList;
exports.getHikeStaff = getHikeStaff;
exports.getParticipant = getParticipant;
exports.getParticipantsSteps = getParticipantsSteps;
exports.getResourceByHikeId = getResourceByHikeId;
exports.getSkillList = getSkillList;
exports.getSpiderData = getSpiderData;
exports.getSurveyTeamEmails = getSurveyTeamEmails;
exports.getSurveys = getSurveys;
exports.getTaskStatus = getTaskStatus;
exports.getVideoUrl = getVideoUrl;
exports.hikeNotifyHikeClientPOC = hikeNotifyHikeClientPOC;
exports.hikeRelatedLoops = hikeRelatedLoops;
exports.reminderTrigger = reminderTrigger;
exports.removeScores = removeScores;
exports.scoreCheckingReport = scoreCheckingReport;
exports.scoreCheckingReportNew = scoreCheckingReportNew;
exports.sendMail = sendMail;
exports.unenrollParticipant = unenrollParticipant;
exports.updateHikeById = updateHikeById;
exports.updateHikeParticipantEnrolledBy = updateHikeParticipantEnrolledBy;
exports.updateParticipantStep = updateParticipantStep;
exports.updateUserOverallScore = updateUserOverallScore;
exports.updateUserScore = updateUserScore;
exports.updateUserScoreNew = updateUserScoreNew;
var _request = _interopRequireDefault(require("@/utils/request"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
// Get Hikes API
function getHikeList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };

  // LHVO-3591 Pass source=adminPortal when calling Get Hikes API, so that it filters records by tenant
  query.source = Constants.SOURCE_ADMIN_PORTAL;
  return (0, _request.default)({
    url: '/hikes',
    method: 'get',
    headers,
    params: query
  });
}
function getHikeById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id,
    method: 'get',
    headers
  });
}
function createHike(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/hikes',
    method: 'post',
    headers,
    data
  });
}
function updateHikeById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/hikes/' + id,
    method: 'put',
    headers,
    data
  });
}
function getHikeStaff(token, id, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/staff',
    method: 'get',
    headers,
    params: query
  });
}
function getResourceByHikeId(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/resources',
    method: 'get',
    headers
  });
}
function getParticipant(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/participants',
    method: 'get',
    headers
  });
}
function getFeedbackResults(token, hikeId, stageId, linkedResource) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  let url = null;
  if (hikeId && stageId && !linkedResource) {
    url = '/survey/hike-feedback-results?hikeId=' + hikeId + '&stageId=' + stageId;
  } else if (linkedResource) {
    url = '/survey/hike-feedback-results?linkedResource=' + linkedResource;
  }
  if (url) {
    return (0, _request.default)({
      url,
      baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
      method: 'get',
      headers
    });
  }
  return false;
}
function getParticipantsSteps(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/participantsSteps',
    method: 'get',
    headers
  });
}
function updateParticipantStep(token, id, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/participantStep',
    method: 'patch',
    headers,
    data
  });
}
function enrollHike(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/user-hikes/register-enroll',
    method: 'post',
    headers,
    data
  });
}
function unenrollParticipant(token, hikeId, userUuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/coach-tools/hikes/' + hikeId + '/users/' + userUuid + '/unenroll',
    method: 'get',
    headers
  });
}
function scoreCheckingReport(token, hikeId, stageId, userUuid, type) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/type/${type}/scores`,
    method: 'get',
    headers
  });
}
function scoreCheckingReportNew(token, hikeId, stageId, userUuid, type) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/type/${type}/scores-new`,
    method: 'get',
    headers
  });
}
function getSpiderData(token, hikeId, stageId, userUuid, type) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/type/${type}/scores`,
    method: 'get',
    headers
  });
}
function getVideoUrl(token, contentId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/contents/${contentId}`,
    method: 'get',
    headers
  });
}
function removeScores(token, hikeId, stageId, userUuid, type, raterId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/raters/${raterId}/remove-all-scores`,
    method: 'delete',
    headers
  });
}
function editComments(token, userHikeReportId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/userhikereports/${userHikeReportId}/edit-comments`,
    method: 'post',
    headers,
    data
  });
}
function addUserScore(token, hikeId, stageId, userUuid, type, actionId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/type/${type}/action/${actionId}/new-scores`,
    method: 'post',
    headers,
    data
  });
}
function addUserScoreNew(token, hikeId, stageId, userUuid, type, actionId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/type/${type}/action/${actionId}/new-scores-new`,
    method: 'post',
    headers,
    data
  });
}
function updateUserScore(token, hikeId, stageId, userUuid, actionId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/action/${actionId}/scores`,
    method: 'post',
    headers,
    data
  });
}
function updateUserScoreNew(token, hikeId, stageId, userUuid, actionId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/action/${actionId}/scores-new`,
    method: 'post',
    headers,
    data
  });
}
function deleteUserScore(token, hikeId, stageId, userUuid, actionId, raterId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/action/${actionId}/rater/${raterId}/scores`,
    method: 'delete',
    headers
  });
}
function deleteUserScoreNew(token, hikeId, stageId, userUuid, actionId, raterId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/action/${actionId}/rater/${raterId}/scores-new`,
    method: 'delete',
    headers
  });
}
function addUserOverallScore(token, hikeId, stageId, userUuid, type, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/${type}/overalls`,
    method: 'post',
    headers,
    data
  });
}
function updateUserOverallScore(token, hikeId, stageId, userUuid, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/overalls`,
    method: 'post',
    headers,
    data
  });
}
function deleteUserOverallScore(token, hikeId, stageId, userUuid, raterId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/rater/${raterId}/overalls`,
    method: 'delete',
    headers
  });
}
function getSkillList(token) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/skills/hike`,
    method: 'get',
    headers
  });
}
function getTaskStatus(token, hikeId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/rater-assignment/job-in-hike-report/${hikeId}`,
    method: 'get',
    headers
  });
}
function getAttendantReport(token, hikeId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/attendance-report/hikes/${hikeId}/checkinattendance`,
    method: 'get',
    headers
  });
}
function getHikeActivityReport(token, hikeId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/attendance-report/hikes/${hikeId}/activity-report`,
    method: 'get',
    headers
  });
}
function getDialTestData(token, hikeId, stageId, userUuid, contentId, raterId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/coach-tools/hikes/${hikeId}/stages/${stageId}/users/${userUuid}/contents/${contentId}/dial-test/raters/${raterId}`,
    method: 'get',
    headers
  });
}
function getSurveys(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/getsurveys',
    method: 'get',
    headers,
    params: query
  });
}
function getSurveyTeamEmails(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  console.log('query:', query);
  return (0, _request.default)({
    url: '/hikes/getSurveyTeamEmails',
    method: 'get',
    headers,
    params: query
  });
}
function getEmailLog(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/get-email-log',
    method: 'get',
    headers,
    params: query
  });
}
function sendMail(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/survey/mgh/sendmail',
    method: 'post',
    headers,
    data
  });
}
function getExportSurveyResult(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/hikes/exportSurveyResult`,
    method: 'get',
    headers,
    params: query
  });
}
function downloadTASRatingExcel(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/scores-new',
    method: 'get',
    headers
  });
}
function reminderTrigger(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/hikes/survey/mgh/reminder-trigger',
    method: 'post',
    headers,
    data
  });
}
function hikeRelatedLoops(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/related-loops',
    method: 'get',
    headers
  });
}
function hikeNotifyHikeClientPOC(token, id, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/hikes/' + id + '/staffs/notify',
    method: 'post',
    headers,
    data
  });
}
function updateHikeParticipantEnrolledBy(token, userId, hikeId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/user-hikes/users/' + userId + '/hikes/' + hikeId + '/enrolledBy',
    method: 'post',
    headers,
    data
  });
}